export default __webpack_public_path__ + "static/comments-placeholder-0290764512fe67c35a360754d3378344.webp";